import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import './WelcomeHeader.css';
import { Is_BrotherPlus_Signup } from "../../../constants/AppMethod";
import { getFeatureSwitchByKey, getLocalSessionData, getUserDataByKey } from '../../../utils/Authentication/handleUserSession';
import i18next from "i18next";
import SmartSavings from "../../../pages/Dashboard/SmartSavings/SmartSavings";
import { countriesWithMandatoryPOTOSConsent, featureSwitchName, LOCALSESSIONDATAKEYS } from "../../../constants/AppConstants";
import UserUtilityBar from "./Notifications/UserUtilityBar";
import { GetUserNotificationsServiceInit } from "../../../store/Notifications/UserNotificationSlice";
import ErrorPage from "../../shared/errorPage/ErrorPage";

const WelcomeHeader = () => {
  const dispatch = useDispatch();
  const IsBrotherPlusFeatureSwitchEnabled = getFeatureSwitchByKey(featureSwitchName.BROTHER_PLUS);
  const IsBrotherPlus_Signup = Is_BrotherPlus_Signup();
  const countryCode = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE)
  const userDeviceRegistrationResponse = useSelector(state => state.ROOTREDUCER_RTK.GetUserDeviceRegistrationService);
  var isDeviceEnrolledToBothServices = false;


  const getUserDisplayName = () => {
    return `${getUserDataByKey('firstName', 'personal_details')} ${getUserDataByKey('lastName', 'personal_details')}`
  };
  const userName = getUserDisplayName();
  const isBrotherPlusSignup = Is_BrotherPlus_Signup();
  useEffect(() => {
    dispatch(GetUserNotificationsServiceInit(4))
  }, [dispatch]);

  if (userDeviceRegistrationResponse.success === true) {
    isDeviceEnrolledToBothServices = (userDeviceRegistrationResponse.data.isBrotherPlusDevice && userDeviceRegistrationResponse.data.isEcoProDevice);
  }

  if (userDeviceRegistrationResponse.error) {
    return <ErrorPage errorInfo={userDeviceRegistrationResponse.error}></ErrorPage>
  }

  return (
    <>
      <div className="welcome-header-wrapper">
        <div className="header-container-welcome-header">
          <div className="header-content-welcome-header">
            <div className="header-title-wrapper-welcome-header">
              <h1 className="h1">{(i18next.t('BROTHER_PLUS.DASHBOARD.BROTHERPLUS_HEADER', { userName }))}</h1>
            </div>
            <div className="user-bar-wrapper-welcome-header">
              <UserUtilityBar />
            </div>
          </div>
          <div className={`bar ${isBrotherPlusSignup ? 'brotherPlusBar' : 'ecoProBar'} bar-welcome-header`} />
        </div>
      </div>
      {
        (countriesWithMandatoryPOTOSConsent.indexOf(countryCode) === -1
          &&
          IsBrotherPlusFeatureSwitchEnabled
          && (isDeviceEnrolledToBothServices || IsBrotherPlus_Signup))
          ? <SmartSavings variant="dashboard" />
          : null
      }
    </>
  );
};

export default WelcomeHeader;
